import React from 'react';
import SkillIcon from './SkillIcon';

const webSkillData = [
   { id: 1, name: 'JavaScript' },
   { id: 2, name: 'React' },
   { id: 3, name: 'PHP' },
   { id: 4, name: 'MySQL' },
   { id: 5, name: 'Tailwind CSS' },
];

const WebSkill = () => (
   <>
      {webSkillData.map(({ id, name }) => (
         <div key={id} className="skill-card group">
            <SkillIcon name={name} className="skill-icon" />
            <p className="skill-name">{name}</p>
         </div>
      ))}
   </>
);

export default WebSkill;
